module.exports = __webpack_public_path__ + "2c57a2fab1ada72f264eb67a8c71ae96.pdf";